import instances from './instances'
import engines from './engines'
import configurations from './configurations'

export default {
  modules: { configurations, instances, engines }
}
